<div class="error-404">
  <header class="ba-content-header ba-with-overlay ba-with-image">
    <div class="ba-header-image">
      <img class="img404" src="assets/images/error404.svg" alt="Fehler 404: Seite nicht gefunden" />
    </div>
    <div class="ba-content-wrap">
      <div class="ba-overlay">
        <h1>Das aufgerufene Angebot ist leider nicht verfügbar.</h1>
      </div>
    </div>
  </header>
  <div class="container-fluid ba-copytext">
    <h2>Mögliche Gründe:</h2>
    <ul>
      <li>Das Angebot befindet sich noch in der Veröffentlichung oder wurde gelöscht.</li>
      <li>Der Beginntermin des Angebots ist bereits abgelaufen.</li>
      <li>Die eingegebene URL ist nicht korrekt.</li>
    </ul>
    <p>
      Wir legen großen Wert darauf, das Studien&shy;angebot immer auf dem neuesten Stand zu halten
      und bitten um Verständnis.
    </p>
    <button (click)="navigateToSuche()" class="ba-btn ba-btn-primary">
      Zurück zur Studiensuche Startseite
    </button>
  </div>
</div>
